import { Component, OnInit, Input } from '@angular/core';
import { IssueType } from 'solar-bo';

@Component({
  selector: 'app-ex-issuerrortype',
  template: '<i class="panel-error" [ngClass]="statusclass"></i>',
  styleUrls: ['./ex-issuerrortype.component.scss']
})
export class ExIssuerrortypeComponent implements OnInit {



  @Input()
  set errortype(value:IssueType){
    this.convertValue(value);
  }

  @Input() set errortypeObj(value:{issueType:IssueType,iconSize:string}){
      this.iconSize=value.iconSize;
    this.convertValue(value.issueType);
  }
  iconSize:string="";
  statusclass="";
  constructor() { }

  ngOnInit() {
  }

  convertValue(value: any): string {
    //
    const st = value;
    let res="";
    if (st === 'TOCXS') {
        res= "panel-error-tocxs fas fa-square " + this.iconSize;
    } else if (st === IssueType.E1PC) {
        res= "panel-error-1pc fas fa-square " + this.iconSize;           
    } else if (st === IssueType.PCS) {
        res= "panel-error-pcs fas fa-square " + this.iconSize;  
    } else if (st === IssueType.E1CC) {
        res= "panel-error-1cc fas fa-square " + this.iconSize;   
    } else if (st === IssueType.CCS) {
        res= "panel-error-ccs fas fa-square " + this.iconSize; 
    } else if (st === IssueType.SMC) {
        res= "panel-error-smc fas fa-square " + this.iconSize;      
    } else if (st === IssueType.PID) {
        res= "panel-error-pid fas fa-square " + this.iconSize;           
    } else if (st === IssueType.DRT) {
        res= "panel-error-drt fas fa-circle " + this.iconSize;  
    } else if (st === IssueType.SDW) {
        res= "panel-error-sdw fas fa-circle " + this.iconSize;   
    } else if (st === IssueType.FUS) {
        res= "panel-error-fus fas fa-square " + this.iconSize; 
    } else if (st === IssueType.BRK) {
        res= "panel-error-brk fas fa-square " + this.iconSize;             
    } else if (st === IssueType.DSC) {
        res= "panel-error-dsc fas fa-square " + this.iconSize; 
    } else if (st === IssueType.CBOX) {
        res= "panel-error-cbox fas fa-square " + this.iconSize;  
    } else if (st === IssueType.DBB) {
        res= "panel-error-unk fas fa-circle " + this.iconSize;  
    } else if (st === IssueType.DLM) {
        res= "panel-error-unk fas fa-circle " + this.iconSize; 
    } else if (st === IssueType.SHC) {
        res= "panel-error-unk fas fa-circle " + this.iconSize;         
    } else if (st === IssueType.IPO) {
        res= "panel-error-unk fas fa-circle " + this.iconSize;  
    } else if (st === IssueType.UNK) {
        res= "panel-error-unk fas fa-circle " + this.iconSize;               
    } else if (st === IssueType.NDM) {
        res= "panel-error-ndm fas fa-square " + this.iconSize;          
    } else {
        res= "";
    }

    let resi="<i class='panel-error" + res + "'></i>";
    this.statusclass=res;
    return resi;
}

}
/* 

*/
